module.exports = __webpack_public_path__ + "img/cnn1.94b519ff.png";